import React, { useState, useEffect } from "react";
// internal imports
import { validateLinkAndSignIn } from "../../services/api";
import CopyRight from "../copyright/CopyRight";

// external imports
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { CircularProgress } from "@mui/material";

import { useLocation } from "react-router-dom";
import useSignIn from "react-auth-kit/hooks/useSignIn";
import { useNavigate } from "react-router-dom";

const VerifyAccount = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("code");
  const key = queryParams.get("key");
  const chargePointId = queryParams.get("chargePointId");
  const [isLinkValid, setIsLinkValid] = useState(false);

  const [isLoading, setIsLoading] = useState(true);

  const signIn = useSignIn();
  const navigate = useNavigate();

  useEffect(() => {
    const validateLink = async () => {
      try {
        await validateLinkAndSignIn(token, key, signIn, navigate,chargePointId);
      } catch (error) {
        setIsLinkValid(false);
        setIsLoading(false);
      }
    };
    validateLink();
  }, [token, key, chargePointId, navigate, signIn]);
  return (
    <>
      {isLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress color="success" />
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Container component="main" maxWidth="xs">
            <CssBaseline />
            {isLinkValid ? (
              <Box
                sx={{
                  marginTop: 6,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Typography
                  component="h1"
                  variant="h5"
                  sx={{ marginBottom: "10px", fontWeight: "bold" }}
                >
                  Authorized successfully
                </Typography>
              </Box>
            ) : (
              <Box
                sx={{
                  marginTop: 6,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h5"
                  align="center"
                  sx={{ marginBottom: "20px", fontWeight: "bold" }}
                >
                  Link is invalid
                </Typography>
              </Box>
            )}
            <CopyRight sx={{ mt: 4, mb: 4 }} />
          </Container>
        </div>
      )}
    </>
  );
};

export default VerifyAccount;
